import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { Store, Select } from '@ngxs/store';
import { StorageService } from 'angular-webstorage-service';
import { debounce } from 'lodash';
import { TrackingService } from '@services/index';
import { AuthService } from '@examsoft/es-login';
import { LayoutState, CloseMenu, OpenNotification, CloseNotification, CloseTimer } from '../../store';
import { TranslationService } from '@examsoft/translation';
var LayoutComponent = /** @class */ (function () {
    function LayoutComponent(storage, trackingService, authService, activatedRoute, router, store, translationService) {
        var _this = this;
        this.storage = storage;
        this.trackingService = trackingService;
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.store = store;
        this.translationService = translationService;
        this.loggedIn = false;
        this.debouncedSetVh = debounce(this.setVh, 16); //60fps
        this.APP_VERSION = "v" + window['APP_VERSION'];
        this.showFooter = { display: 'none' };
        this.notification = {};
        this.timerOverlay = false;
        this.timerSeconds = this.storage.get('timer') || 0;
        this.translationService.initialise();
        this.authService.init().subscribe(function () {
            _this.sendToDefaultRoute();
        });
        this.authService.loggedIn.pipe(distinctUntilChanged())
            .subscribe(function (data) {
            _this.loggedIn = data;
            if (data) {
                var user = _this.authService.user;
                _this.trackingService.ready(user.username, user['custom:es-id'], 'logged-in', { userAgent: navigator.userAgent });
            }
        });
        this.setVh();
        this.network();
        window.addEventListener('resize', this.debouncedSetVh);
    }
    Object.defineProperty(LayoutComponent.prototype, "isReady$", {
        get: function () {
            return this.translationService.isReady$;
        },
        enumerable: true,
        configurable: true
    });
    LayoutComponent.prototype.sendToDefaultRoute = function () {
        var currentUrl = window.location.pathname;
        var url;
        if (this.authService.isAdmin() && !currentUrl.match(/\/admin\//)) {
            url = '/admin';
        }
        else if (!this.authService.isAdmin() && !currentUrl.match(/^\/poll\//)) {
            url = '/launcher';
        }
        if (url) {
            this.router.navigateByUrl(url);
        }
    };
    LayoutComponent.prototype.network = function () {
        var _this = this;
        var offlineMsg = this.translationService.get('You are offline.');
        var onlineMsg = this.translationService.get('You are online.');
        if (!window['navigator'].onLine) {
            this.store.dispatch(new OpenNotification('warning', offlineMsg));
        }
        window.addEventListener('online', function (event) { _this.store.dispatch(new CloseNotification('success', onlineMsg)); });
        window.addEventListener('offline', function (event) { _this.store.dispatch(new OpenNotification('warning', offlineMsg)); });
        this.showNotification$.subscribe(function (data) { return _this.notification = data; });
    };
    LayoutComponent.prototype.closeNotification = function () {
        var dismissedMsg = this.translationService.get('Dismissed Notification');
        this.store.dispatch(new CloseNotification('info', dismissedMsg));
    };
    LayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events
            .pipe(filter(function (evt) { return evt instanceof NavigationEnd; }), map(function () { return _this.activatedRoute; }), map(function (route) {
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        }))
            .subscribe(function (route) {
            _this.showFooter.display = location.pathname.match(/admin\/list|login/) ? 'block' : 'none';
        });
    };
    LayoutComponent.prototype.toggleTimer = function (data) {
        if (data !== null) {
            this.storage.set('timer', data);
        }
        this.store.dispatch(new CloseTimer());
    };
    LayoutComponent.prototype.closeMenu = function (event) {
        var _this = this;
        var menuOpen$ = this.showMenu$.subscribe(function (isOpen) {
            if (isOpen) {
                _this.store.dispatch(new CloseMenu());
                event.stopPropagation();
            }
        });
        menuOpen$.unsubscribe();
    };
    LayoutComponent.prototype.setVh = function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + "px");
    };
    LayoutComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('resize', this.debouncedSetVh);
        this.authService.loggedIn.unsubscribe();
    };
    tslib_1.__decorate([
        Select(LayoutState.getShowMenu),
        tslib_1.__metadata("design:type", Observable)
    ], LayoutComponent.prototype, "showMenu$", void 0);
    tslib_1.__decorate([
        Select(LayoutState.getShowNotification),
        tslib_1.__metadata("design:type", Observable)
    ], LayoutComponent.prototype, "showNotification$", void 0);
    tslib_1.__decorate([
        Select(LayoutState.getShowTimer),
        tslib_1.__metadata("design:type", Observable)
    ], LayoutComponent.prototype, "showTimer$", void 0);
    return LayoutComponent;
}());
export { LayoutComponent };
